import { render, staticRenderFns } from "./PdfFull.vue?vue&type=template&id=646db0bf&"
import script from "./PdfFull.vue?vue&type=script&lang=js&"
export * from "./PdfFull.vue?vue&type=script&lang=js&"
import style0 from "./PdfFull.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VImg,VLayout})
